import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="" align="center">
                                            <img alt="" style={{maxWidth:'100%'}}
                                                 src={require('@images/How to make complex ideas simple, clear and concise.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>isn't it interesting?
                                            </div>

                                            <div className="border_subtitle">What is happening in this
                                                picture?<img
                                                    src={require('@images/dice.png')}
                                                    alt="" align="right"/></div>
                                            <div><p>At first glance this picture makes sense. However, when
                                                you look in
                                                more detail you realise that this is an optical illusion and
                                                is actually
                                                fairly complex. Our brain initially tries to make sense of
                                                the picture
                                                but when this is not possible we use techniques such as
                                                concentrating
                                                on the part that makes sense, squinting or moving away from
                                                the
                                                picture. How would you explain the picture so someone else
                                                could
                                                understand what you are looking at?</p></div>

                                            <div
                                                className="lightgreencontentbg keyquestionpadnew lightbgcenter">
                                                <div className="border_subtitle">It’s a set of white
                                                    dice...
                                                </div>
                                                <span className="pad-sept"><p
                                                    style={{paddingBottom:'8px !important'}}>There are a number of explanations that you might give to others. These depend on a
number of factors such as which part of the detail you reflect on, how rational you are, what
you choose to communicate to people, and how.</p></span>
                                                <div className="paraspace"><p>You might say, for
                                                    example:</p></div>
                                                <ul className="greenbullet-list uiheading">
                                                    <li><p>The picture is an optical illusion that shows a
                                                        number of white dice in a triangle shape
                                                        which looks real but can’t be.</p></li>
                                                    <li><p>The dice have been manipulated so it looks like
                                                        two sides are lying flat on the table with
                                                        the final side standing upright at a 90 degree
                                                        angle.</p></li>
                                                    <li className="content_removebottom"><p>The image
                                                        doesn’t make sense as it doesn’t comply with the
                                                        laws of physics.</p></li>
                                                </ul>
                                            </div>

                                            <p className="paratop_lightbg">When making complex ideas clear
                                                and concise you need to engage with your audience, which is
                                                dependent on your understanding their needs in order to
                                                pitch your message appropriately. If
                                                people are familiar with, and able to understand, your
                                                concepts then they are more likely to
                                                challenge you, which means that your points will require
                                                more thought. If people are not familiar
                                                with the information they are presented with, or the
                                                situation is ambiguous, they are more likely
                                                to rely on peripheral characteristics such as your perceived
                                                credibility and attractiveness, hence
                                                the use of ‘attractive’ celebrities in advertising.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>1</sup></a></p>

                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}